import React from 'react';
import { Menu, MenuItem } from '@blueprintjs/core';
import i18n from 'i18n';
import { COMMON_GRID_ACTION } from '../../shared/commonGrid/grid-enums';

class AttachmentActionMenu extends React.Component<any, any> {
  render() {
    const ctx = this.props.context;
    const menuItemDisabled = !ctx.state.selection.length;

    const showViewActionMenu = (
      (ctx.props.showActionMenuItem === undefined
          && ctx.props.hasPrivilegetoView !== undefined
          && ctx.props.hasPrivilegetoView && this.props.data.newAddedAttachment !== true));
    const showDownloadActionMenu = (
      (ctx.props.showActionMenuItem === undefined
          && ctx.props.hasPrivilegeToDownload !== undefined
          && ctx.props.hasPrivilegeToDownload && this.props.data.newAddedAttachment !== true));
    const showDeleteActionMenu = (
      (ctx.props.showActionMenuItem === undefined
          && ctx.props.hasPrivilegeToDelete !== undefined
          && ctx.props.hasPrivilegeToDelete));

    return (
      <Menu>
        {
          // eslint-disable-next-line max-len
          showViewActionMenu && (
          <MenuItem
            id={COMMON_GRID_ACTION.View}
            onClick={ctx.onActionMenuItemClick}
            disabled={menuItemDisabled}
            text={i18n.t('common.grid.action.view')}
          />
          )
}
        {
          showDownloadActionMenu && (
            <MenuItem
              id={COMMON_GRID_ACTION.Download}
              onClick={ctx.onActionMenuItemClick}
              disabled={menuItemDisabled}
              text={i18n.t('common.grid.action.download')}
            />
          )
}
        {
          showDeleteActionMenu && (
          <MenuItem
            id={COMMON_GRID_ACTION.Delete}
            onClick={ctx.onActionMenuItemClick}
            disabled={menuItemDisabled}
            text={i18n.t('common.grid.action.delete')}
          />
          )
}
      </Menu>
    );
  }
}

export default AttachmentActionMenu;
